import { Component, effect, input, ChangeDetectionStrategy } from '@angular/core';
import { RangeValidator } from '../../input/validator/range-validator';
import { Register } from '@xanadu/core';

@Component({
    selector: 'app-number-meta',
    templateUrl: './number-meta.component.html',
    styleUrls: ['./number-meta.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Register('number-meta')
export class NumberMetaComponent {
    model = input<any>();

    metaMin: any = { id: 'min', name: 'Minimum' };
    metaMax: any = { id: 'max', name: 'Maximum' };
    metaStep: any = { id: 'step', name: 'Step' };

    constructor() {
        effect(() => {
            const model = this.model();
            if (model) {
                model.meta.formGroup.setValidators([RangeValidator()]);
            }
        });
    }
}
